import { stateTint, surface } from '@afarinesh/luma-store-ui-kit';

/**
 * The kit's tokens that cssVariables() does not yet emit.
 *
 * stateTint and the desk/hover surfaces exist in the kit as TypeScript objects
 * but never reach CSS, so anything styling a status card in plain CSS or an
 * inline style has to reach for a hex — which is exactly how the cashier ends
 * up a slightly different green from the panel.
 *
 * Derived from the kit's own exports rather than retyped, so the kit stays the
 * single source. This belongs in the kit's cssVariables() proper; it lives here
 * until that ships, and the values are identical either way.
 */
export function extraVars(): string {
  const lines = [
    `--luma-surface-desk: ${surface.desk}`,
    `--luma-surface-hover: ${surface.hover}`,
  ];

  for (const [name, tint] of Object.entries(stateTint)) {
    lines.push(`--luma-tint-${name}-bg: ${tint.bg}`);
    lines.push(`--luma-tint-${name}-border: ${tint.border}`);
    lines.push(`--luma-tint-${name}-text: ${tint.text}`);
  }

  return `:root{${lines.join(';')}}`;
}
